import artwork01 from './assets/images/artwork/01.jpg';
import artwork02 from './assets/images/artwork/02.jpg';
import artwork03 from './assets/images/artwork/03.jpg';
import artwork04 from './assets/images/artwork/04.jpg';

import audio01 from './assets/files/zh-HK/01.mp3';
import audio02 from './assets/files/zh-HK/02.mp3';
import audio03 from './assets/files/zh-HK/03.mp3';
import audio04 from './assets/files/zh-HK/04.mp3';

import audio01EN from './assets/files/en/01.mp3';
import audio02EN from './assets/files/en/02.mp3';
import audio03EN from './assets/files/en/03.mp3';
import audio04EN from './assets/files/en/04.mp3';


const STORIES = [
  {
    title: 'Episode 0：序',
    desc: '張伯樂從逆時世界回到現實，失去了過去六年的記憶，腦海卻反覆出現一把女歌聲。他尋遍不同香港女歌手的唱片，只為重新遇見那個被他忘記的人。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork01,
    soundTrack: audio01,
    soundTrackEN: audio01EN
  },
  {
    title: 'Episode 1：原地轉',
    desc: '在現實世界重遇後，張伯樂與李蜜兒一同重新面對各自的生活與創作，過程並不盡如人意。一天，他們收到一個神秘包裹，而寄件人竟然知道逆時世界的秘密。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork02,
    soundTrack: audio02,
    soundTrackEN: audio02EN
  },
  {
    title: 'Episode 2：機會論',
    desc: '二人的事業、愛情與生活都不如意，面對一個重新來過的機會，各有取態。究竟他們誰才是對世界有希望的積極者，誰才是正在「向前」走？',
    descEN: '',
    subTitle: '',
    imageSrc: artwork03,
    soundTrack: audio03,
    soundTrackEN: audio03EN
  },
  {
    title: 'Episode 3：相信你',
    desc: '李蜜兒邀請張伯樂為她「最後的」demo填詞，於是張伯樂四出為歌詞找靈感，同時也為禁畫找答案、為生活找出口⋯⋯· 究竟他們會作出甚麼決定？',
    descEN: '',
    subTitle: '',
    imageSrc: artwork04,
    soundTrack: audio04,
    soundTrackEN: audio04EN
  }
];

export default STORIES;
